import Vue from 'vue'
import lodash from 'lodash'

export default {

	install: function (Vue) {

		Vue.prototype.$_ = lodash

	}
}


// WEBPACK FOOTER //
// ./src/helpers/lodash.js